import axios from 'axios'

import { ProductForImportInterface, ProductInterface, ProductTypesEnum } from '../Interfaces/ProductInterface'
import { getRequestConfig } from './index'

export async function getProducts(): Promise<ProductInterface[]> {
  const response = await axios.get('/platform/v4/products', getRequestConfig())
  return response.data
}

export async function importProducts(products: ProductForImportInterface[]): Promise<ProductInterface[]> {
  const response = await axios.post('/platform/v4/products/import', products, getRequestConfig())
  return response.data
}

export async function getProduct(id: number): Promise<ProductInterface> {
  const response = await axios.get(`/platform/v4/products/${id}`, getRequestConfig())
  return response.data
}

export async function addProduct(product: ProductInterface): Promise<ProductInterface> {
  const response = await axios.post('/platform/v4/products', product, getRequestConfig())
  return response.data
}

export async function updateProduct(product: Partial<ProductInterface>): Promise<ProductInterface> {
  const response = await axios.patch(`/platform/v4/products/${product?.id}`, product, getRequestConfig())
  return response.data
}

export async function updateProducts(ids: number[], changes: Partial<ProductInterface>): Promise<ProductInterface[]> {
  const response = await axios.patch(`/platform/v4/products?ids=${ids}`, changes, getRequestConfig())
  return response.data
}

export async function updateAllNotSetProductsProductType(productType: ProductTypesEnum): Promise<void> {
  const response = await axios.patch('/platform/v4/products/product-type', { productType }, getRequestConfig())
  return response.data
}

export async function deleteProduct(id: number): Promise<number> {
  const response = await axios.delete(`/platform/v4/products/${id}`, getRequestConfig())
  return response.data || id
}

export async function deleteProducts(ids: number[]): Promise<number[]> {
  const response = await axios.delete(`/platform/v4/products?ids=${ids}`, getRequestConfig())
  return response.data || ids
}

export async function calculateProductPrice(product: Partial<ProductInterface>): Promise<Partial<ProductInterface>> {
  const response = await axios.post('/platform/v4/products/precalculate', product, getRequestConfig())
  return response.data
}
